export default __webpack_public_path__ + "static/transversal-medellin-c054ceeb0b29893263264a9badfbfd3a.jpg";